/**
 * KitExpiredPage
 * Page displayed when Kit de Atendimento link has expired
 *
 * @version 2025.1.0
 */

import React from 'react';
import {
  Box,
  Typography,
  Alert,
  Paper,
  Button,
} from '@mui/material';
import {
  AccessTime as ExpiredIcon,
  Phone as PhoneIcon,
} from '@mui/icons-material';

export const KitExpiredPage: React.FC = () => {
  return (
    <Box
      bgcolor="background.default"
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={4}
    >
      {/* Mesma caixa do antigo <Container maxWidth="sm"> desta página pública sem cabeçalho */}
      <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto', px: { xs: 2, sm: 3 } }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          {/* Icon */}
          <Box sx={{ mb: 3 }}>
            <ExpiredIcon sx={{ fontSize: 80, color: 'warning.main' }} />
          </Box>

          {/* Title */}
          <Typography variant="h4" gutterBottom fontWeight="bold">
            Link Expirado
          </Typography>

          {/* Description */}
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            O link de acesso ao Kit de Atendimento expirou.
            Os links sao validos por 30 dias apos a geracao.
          </Typography>

          {/* Alert */}
          <Alert
            severity="warning"
            icon={<PhoneIcon />}
            sx={{ mb: 3, textAlign: 'left' }}
          >
            <Typography variant="body2">
              Para obter um novo link, entre em contato com a recepcao da clinica
              onde realizou seu atendimento.
            </Typography>
          </Alert>

          {/* Instructions */}
          <Box sx={{ bgcolor: 'action.hover', borderRadius: 2, p: 2, mb: 3 }}>
            <Typography variant="subtitle2" gutterBottom>
              O que fazer agora?
            </Typography>
            <Typography variant="body2" color="text.secondary" component="ol" sx={{ textAlign: 'left', pl: 2 }}>
              <li>Entre em contato com a recepcao da clinica</li>
              <li>Informe seus dados (nome e CPF)</li>
              <li>Solicite um novo link de acesso</li>
              <li>Voce recebera o novo link por email ou WhatsApp</li>
            </Typography>
          </Box>

          {/* Back Button */}
          <Button
            variant="outlined"
            onClick={() => window.close()}
            sx={{ mt: 2 }}
          >
            Fechar Pagina
          </Button>
        </Paper>
      </Box>
    </Box>
  );
};

export default KitExpiredPage;
